import React from 'react';
import ProjectItem from '@gp/components/ProjectItem';
import { getFormatNumPlus, getFormatPercentPlus } from '@gp/utils/common';
import { CONSTANT_TEXTS } from '@gp/constants/const';

/**
 * 获取表格配置项
 */
const getColumns = (year: string, month: string, toDetails?: Function) => {
  const options = [
    {
      key: 'project',
      width: 240,
      header: 'Project',
      fixed: 'left',
      render: (cvm: any) => {
        return (
          <ProjectItem
            src={cvm?.cover || ''}
            title={cvm?.project_name || '-'}
            platform={cvm?.platform}
            data={cvm}
            toDetails={toDetails}
          />
        );
      },
    },
    {
      key: 'total_dev_budget',
      width: 160,
      align: 'right',
      header: (
        <div className="dbg-table-header-text">
          Approved Dev
          <br />
          Budget($)
        </div>
      ),
      render: (cvm: any) => {
        return getFormatNumPlus(cvm?.total_dev_budget || '');
      },
    },
    {
      key: 'total_spent_to_date',
      width: 160,
      align: 'right',
      header: (
        <div className="dbg-table-header-text">
          Total Spent
          <br />
          to Date($)
        </div>
      ),
      render: (cvm: any) => {
        return getFormatNumPlus(cvm?.total_spent_to_date || '');
      },
    },
    {
      key: 'total_spent_budget_percent',
      width: 222,
      align: 'right',
      header: (
        <div className="dbg-table-header-text">
          Total Spent to Date/
          <br />
          {CONSTANT_TEXTS.APPROVED_DEVELOPMENT_BUDGET_SIMPLE}
        </div>
      ),
      render: (cvm: any) => {
        return getFormatPercentPlus(cvm?.total_spent_budget_percent || '', 2);
      },
    },
    {
      key: 'dev_budget',
      width: 160,
      align: 'right',
      header: (
        <div className="dbg-table-header-text">
          {year || '-'} Dev
          <br />
          Budget($)
        </div>
      ),
      render: (cvm: any) => {
        return getFormatNumPlus(cvm?.dev_budget || '');
      },
    },
    {
      key: 'spent_to_date',
      width: 160,
      align: 'right',
      header: (
        <div className="dbg-table-header-text">
          {year || '-'} Spent
          <br />
          to Date($)
        </div>
      ),
      render: (cvm: any) => {
        return getFormatNumPlus(cvm?.spent_to_date || '');
      },
    },
    {
      key: 'spent_budget_percent',
      width: 220,
      align: 'right',
      header: (
        <div className="dbg-table-header-text">
          {year || '-'} Spent to Date/
          <br />
          {year || '-'} Dev Budget
        </div>
      ),
      render: (cvm: any) => {
        return getFormatPercentPlus(cvm?.spent_budget_percent || '', 2);
      },
    },
    {
      key: 'dev_cost',
      width: 160,
      align: 'right',
      header: (
        <div className="dbg-table-header-text">
          {year && month ? year + '.' + month : '-'} Dev
          <br />
          Cost($)
        </div>
      ),
      render: (cvm: any) => {
        return getFormatNumPlus(cvm?.dev_cost || '');
      },
    },
  ];

  return options;
};

export { getColumns };
